export const TIME_RANGE_OPTIONS = [
  { value: "", label: "All time" },
  { value: "1", label: "24 hours" },
  { value: "7", label: "7 days" },
  { value: "30", label: "30 days" },
];

export const RUN_FILTER_KEYS = [
  "q",
  "workflow",
  "status",
  "trigger",
  "repository",
  "days",
] as const;

export const ACTIVITY_FILTER_KEYS = [
  "assignee",
  "q",
  "review",
  "type",
  "repository",
  "days",
  "time",
  "filter",
] as const;

export const PEOPLE_FILTER_KEYS = ["filter", "q", "state", "tags", "company", "assignee"] as const;

export const COMPANY_FILTER_KEYS = ["filter", "q", "domain", "tags", "assignee"] as const;
